export default __webpack_public_path__ + "static/media/Parent_Illustrations-16.4e657cef.svg";